import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import {
  getAccessTokenFromLocalStorage,
  getRefreshTokenFromLocalStorage,
  setAccessTokenInLocalStorage,
} from './localStorage';
import {
  getFromLocalStorage,
  constants as localStorageConstants,
} from 'app/utils/localStorage';
import api from './env';
import { apiRoutes } from 'auth/utils/apiRoutes';

const httpDriver = axios.create({
  baseURL: api.API_BASE_URL,
});
httpDriver.interceptors.request.use(
  (request) => {
    const token = getAccessTokenFromLocalStorage();
    const lng = getFromLocalStorage(localStorageConstants.language);
    return {
      ...request,
      headers: {
        ...request.headers,
        skipAuthRefresh: true,
        Authorization: `bearToken ${token}`,
        'Accept-Language': lng,
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

const refreshAuth = (failedRequest) =>
  httpDriver({
    method: 'post',
    url: apiRoutes.refreshToken,
    skipAuthRefresh: true,

    data: { refresh_token: getRefreshTokenFromLocalStorage() },
  })
    .then((response) => {
      setAccessTokenInLocalStorage(
        response.data.payload?.records?.access_token
      );
      failedRequest.response.config.headers.Authorization = `bearToken ${getAccessTokenFromLocalStorage()}`;
      return Promise.resolve();
    })
    .catch((error) => {
      throw error;
    });
createAuthRefreshInterceptor(httpDriver, refreshAuth, {
  statusCodes: [403],
});

export default httpDriver;
